<div id="appCapsule">
    <div class="d-flex justify-content-center">
        <img src="assets/img/icon/icon.png" alt="" width="100">
    </div>    
    <h2 class="text-danger text-center pt-2">Page Not Fount</h2>
</div>